import { ShoppingCart } from '../../models/shopping-cart';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'shipping-order-summary',
  templateUrl: './shipping-order-summary.component.html',
  styleUrls: ['./shipping-order-summary.component.css']
})
export class ShippingOrderSummaryComponent {

  constructor() { }
  @Input('cart') cart: ShoppingCart;
  
}



// WEBPACK FOOTER //
// G:/MyProjects/Angular/oshop/src/app/check-out/shipping-order-summary/shipping-order-summary.component.ts